import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'
import {cn} from '@containers/html-utils'
import {stickerCtl} from '@extensions/sticker/sticker'
import {useStickerEditorStore} from './sticker-editor-store'
import {StringStateEdit} from './string-state-edit/string-state-edit'
import {StringStateItemWrapper} from './string-state-item/string-state-item-wrapper'

const stringCtl = stickerCtl.String

export const StringStates = observer(() => {
  const [state, store] = useStickerEditorStore()

  useEffect(() => {
    state.sticker && store.setStringStates(stringCtl.listStates(state.sticker))
  }, [state.stringState, state.sticker, state.stickerEdited])

  return (
    <div className="flex flex-col gap-8 py-8">
      <div className="text-sm-semibold">{Lang.msg.myStickers.states}</div>
      {state.sticker &&
        state.stringStates.map(state => (
          <StringStateItemWrapper stringStickerState={state} key={state.id} />
        ))}
      {state.stickerEdited ? (
        <StringStateEdit />
      ) : (
        <LinkButtonNew
          icon="IconPlus"
          title={Lang.msg.myStickers.addState}
          onClick={store.addStringState}
          className={cn('mt-8', state.stringStates.length && 'ml-16')}
        />
      )}
    </div>
  )
})
